// apps/roleforge-app/src/components/audit/AiTeamPreviewTile.tsx
//
// Plan 3e-ii Task 5.6 — Single-agent preview tile for the AI team strip
// on the Activation Moment screen.

export interface AiTeamPreviewTileProps {
  agentName: string;
  role: string;
  firstTask: string;
}

export function AiTeamPreviewTile({ agentName, role, firstTask }: AiTeamPreviewTileProps) {
  return (
    <div className="flex-1 rounded-lg border border-slate-200 dark:border-slate-700 bg-card p-4 min-w-0">
      <p className="text-sm font-semibold text-slate-900 dark:text-slate-100 truncate">{agentName}</p>
      <p className="text-xs text-slate-500 mt-1 truncate">{role}</p>
      <p className="text-xs text-slate-700 dark:text-slate-300 mt-3 line-clamp-2">{firstTask}</p>
    </div>
  );
}
